var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoggedIn || _vm.$route.name === 'beranda')?_c('Navbar'):_vm._e(),_c('v-main',{class:{ 'green-dark-background': _vm.greenDarkBackground }},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }